<template>
  <div>
    <el-form :inline="true" :model="formClass" label-width="70px">
      <el-form-item label="兑换码:" v-if="invitaCodeObj.type != 1">
        <el-input
          v-model="formClass.subCouponName"
          placeholder=""
          size="small"
        ></el-input>
      </el-form-item>
      <el-form-item label="生成日期:" label-width="80px">
        <DatePicker
          v-model="formClass.createdTime"
          type="date"
          format="yyyy-MM-dd"
          placement="bottom-end"
          :clearable="true"
        ></DatePicker>
      </el-form-item>
      <el-form-item label="UID:">
        <el-input v-model="formClass.Uid" size="small"></el-input>
      </el-form-item>
      <el-form-item label="状态:">
        <el-select
          v-model="formClass.status"
          clearable
          style="width: 175px"
          size="small"
        >
          <el-option
            v-for="item in statusGoods"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          ></el-option>
        </el-select>
      </el-form-item>

      <el-form-item>
        <el-button type="primary" icon="search" @click="onQuery"
          >搜索</el-button
        >
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
export default {
  name: "queryInvitationDetail",
  components: {},
  data() {
    return {
      invitaCodeObj: {},
      formClass: {
        Uid: "",
        status: "",
        createdTime: "",
        subCouponName: "",
      },
      statusGoods: [
        {
          value: 3,
          label: "已使用",
        },
        {
          value: 2,
          label: "已过期",
        },
        {
          value: 4,
          label: "未领取",
        },
        {
          value: 5,
          label: "已领取",
        },
        {
          value: 14,
          label: "已收回",
        },
        {
          value: 15,
          label: "已注销",
        },
      ],
      queryParams: {
        page: 1,
        pageSize: 20,
      },
    };
  },
  props: {},
  created() {
    this.invitaCodeObj = this.$route.query;
    // console.log(this.$route.query);
  },
  mounted() {},
  watch: {},
  methods: {
    onQuery() {
      this.$emit("queryCouponSubsResult", this.formClass);
    },
  },
};
</script>

<style lang="less" scoped>
@import "../../fyd-style";
@import "../../commonEdu";
</style>


// WEBPACK FOOTER //
// queryInvitationDetail.vue?3643fa11